export default __webpack_public_path__ + "static/media/lotto.4686aa5b.svg";